import { render } from "./PurchasePage.vue?vue&type=template&id=cd627410&scoped=true"
import script from "./PurchasePage.vue?vue&type=script&lang=js"
export * from "./PurchasePage.vue?vue&type=script&lang=js"

import "./PurchasePage.vue?vue&type=style&index=0&id=cd627410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd627410"]])

export default __exports__